import React, { Fragment, useContext, useEffect } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, Btn } from "../../../AbstractElements";
import { PlusCircle } from "react-feather";
import TableSearch from "../../../Shared/Components/Search/TableSearch";
import RoleContext from "../ContextProvider/Index";
import RoleForm from "./RoleForm";
import DataTableRolesComponent from "./DataTableRolesComponent";
import { hasPermission } from "../../../Shared/Utils/userUtils";

const RolesList = () => {
  const { setSearchTerm, modalTogle, setItem } = useContext(RoleContext);

  const handleNew = () => {
    setItem({});
    modalTogle();
  };

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, []);

  return (
    <Fragment>
      <Breadcrumbs parent="Admin" title="Roles" mainTitle="Roles" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="data-tables">
                <Row className="project-list">
                  <Col md="4">
                    <TableSearch onSearch={setSearchTerm} />
                  </Col>
                  <Col sm="8" className="p-0">
                    {hasPermission("create_role") ? (
                      <div className="text-end">
                        <Btn
                          attrBtn={{
                            color: "primary",
                            className: "btn btn-primary text-white",
                            onClick: handleNew,
                          }}
                        >
                          <PlusCircle />
                          Nuevo Rol
                        </Btn>
                        <RoleForm />
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="12">
                    <DataTableRolesComponent />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default RolesList;
